import {PrivateCommand} from "../PrivateCommand";
import clientConfig from "../../../client-config";

export class isGDPRExcludedPrivateCommand extends PrivateCommand {

    /* INSTANCE */
    public override execute(option?: string, callback?: (exclude: boolean) => void) {
        if (callback) {
            callback(clientConfig().exclude_gdpr);
        }
    }
}
